<template>
    <div></div>
</template>

<script lang="ts" setup>
import type { ICategory } from "~/libs/types/api/category";

const route = useRoute();

const props = defineProps({
    category: {
        type: Object as PropType<ICategory>,
        required: true,
    },
});

defineOgImageComponent("Main", {
    title: props.category.name,
    image: props.category.thumb?.original_url,
    path: route.path,
});

const cleanCanonical = computed(() => `https://northland-co.com/category/${props.category.slug}`);

useSeoMeta({
    title: props.category.seo?.title ? `${props.category.seo.title} | نرس‌لند` : `خرید ${props.category.name} | رستری قهوه نرس‌لند`,
    description: props.category.seo?.description ?? `مشاهده مشخصات و خرید آنلاین انواع ${props.category.name} با بهترین قیمت و ارسال سریع از رستری قهوه نرس‌لند.`,
    robots: props.category.seo?.robots ?? "index, follow",
    canonical: cleanCanonical,
    ogTitle: props.category.seo?.og_title ?? `خرید ${props.category.name} | نرس‌لند`,
    ogDescription: props.category.seo?.og_description ?? `مشاهده مشخصات و خرید آنلاین انواع ${props.category.name} در فروشگاه نرس‌لند.`,
    ogType: "website",
    ogUrl: cleanCanonical,
});

useSchemaOrg([
    defineBreadcrumb({
        itemListElement: [
            { name: "خانه", item: "/" },
            { name: "دسته‌بندی‌ها", item: "/category" },
            { name: props.category.name, item: cleanCanonical.value },
        ],
    }),
]);
</script>

<style></style>
